import { GetStaticProps } from 'next';
import { defineMessages, useIntl } from 'react-intl';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import SceneCardContainer from '@/components/app/scenes/SceneCardContainer';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest, useInitState } from '@/hooks/store';

const messages = defineMessages({
	title: {
		id: 'app.components.screenTitle.scenesHeading',
		defaultMessage: 'Scenes',
		description: 'The title of the scenes selection page (background video that plays)',
	},
});

const Scenes = () => {
	useInitState({ requests: [InitRequest.USER, InitRequest.DEVICE] });
	const { formatMessage } = useIntl();

	return (
		<Layout pageName="scenes">
			<Text el="h1" color="white" weight={FontWeights.Regular} size={FontSizes.xl}>
				{formatMessage(messages.title)}
			</Text>
			<SceneCardContainer />
		</Layout>
	);
};

export default Scenes;

export const getStaticProps: GetStaticProps = async () => {
	return {
		props: {
			appHeaderProps: {
				pageTitle: messages.title,
			},
			initialState: {
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
